// extracted by mini-css-extract-plugin
export var deleteModal = "_qb-0";